/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Letterpreviewdisclaimerpt4Inputs */

const en_letterpreviewdisclaimerpt4 = /** @type {(inputs: Letterpreviewdisclaimerpt4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Esta carta é uma comunicação amigável preparada com apoio do ClaimPack. Não constitui aconselhamento jurídico nem notificação formal. Para a interpelação admonitória registada e os efeitos legais associados, consulte um advogado.`)
};

const pt_letterpreviewdisclaimerpt4 = /** @type {(inputs: Letterpreviewdisclaimerpt4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Esta carta é uma comunicação amigável preparada com apoio do ClaimPack. Não constitui aconselhamento jurídico nem notificação formal. Para a interpelação admonitória registada e os efeitos legais associados, consulte um advogado.`)
};

/**
* | output |
* | --- |
* | "Esta carta é uma comunicação amigável preparada com apoio do ClaimPack. Não constitui aconselhamento jurídico nem notificação formal. Para a interpelação adm..." |
*
* @param {Letterpreviewdisclaimerpt4Inputs} inputs
* @param {{ locale?: "en" | "pt" }} options
* @returns {LocalizedString}
*/
const letterpreviewdisclaimerpt4 = /** @type {((inputs?: Letterpreviewdisclaimerpt4Inputs, options?: { locale?: "en" | "pt" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Letterpreviewdisclaimerpt4Inputs, { locale?: "en" | "pt" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_letterpreviewdisclaimerpt4(inputs)
	return pt_letterpreviewdisclaimerpt4(inputs)
});
export { letterpreviewdisclaimerpt4 as "letterPreviewDisclaimerPT" }